<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>
        
        <!-- Contatos do coordenador -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao" v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
              <label>Contatos do coordenador (disponíveis apenas para os administradores do sistema e para os usuários PROEX)</label>
            </div>
          </v-flex>
        </v-layout>

        <div v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
          <br>
        </div>

        <!-- E-mail -->
        <v-layout row v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
          <v-flex xs12>
            <v-text-field label="E-mail*" v-model="contatos.emailCoordenador" counter="50" :rules="regras50"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
          <v-flex xs12>
            <v-text-field label="Telefone*" v-model="contatos.telefoneCoordenador" counter="50" :rules="regras50"></v-text-field>
          </v-flex>
        </v-layout>

        <div v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
          <br>
        </div>
        
        <!-- Contatos da ação de extensão -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao" v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
              <label>Contatos da ação de extensão (as informações de contato abaixo ficarão disponíveis para a consulta pública)</label>
            </div>
          </v-flex>
        </v-layout>

        <div v-if="administrador === true || usuarioPROEX === true || projeto.funcao.item === 1 || projeto.assessor === true">
          <br>
        </div>

        <!-- Site -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="Site" v-model="contatos.site" counter="100" :rules="regras100"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Instagram -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="Instagram" v-model="contatos.instagram" counter="100" :rules="regras100"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Facebook -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="Facebook" v-model="contatos.facebook" counter="100" :rules="regras100"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Youtube -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="Youtube" v-model="contatos.youtube" counter="100" :rules="regras100"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Outras mídias sociais -->
        <v-layout row>
          <v-flex xs12>
            <v-textarea label="Outras mídias sociais" rows="1" auto-grow v-model="contatos.midiasSociais" counter="100" :rules="regras100"></v-textarea>
          </v-flex>
        </v-layout>

        <!-- Nome do contato -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="Nome do contato" v-model="contatos.nomeContato" counter="200" :rules="regras200"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- E-mail -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="E-mail*" v-model="contatos.email" counter="60" :rules="regras60"></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field label="Telefone" v-model="contatos.telefone" counter="30" :rules="regras30"></v-text-field>
          </v-flex>
        </v-layout>

      </v-container>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="editarContatos(false)" :disabled="!formularioValido">Salvar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'projeto'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      contatos: {
        site: '',
        midiasSociais: '',
        nomeContato: '',
        email: '',
        telefone: ''
      },
      projeto: {
        titulo: '',
        projetoSup: undefined,
        resumo: '',
        dataInicial: '',
        dataFinal: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      pesquisa: {
        titulo: undefined
      },
      listaTipoPublico: [],
      listaTipoEvento: [],
      listaSituacao: [],
      regras100: [
        (input) => input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres'
      ],
      regras200: [
        (input) => input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ],
      regras60: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => input.length <= 60 || 'Este campo não pode possuir mais que 60 caracteres'
      ],
      regras30: [
        (input) => input.length <= 30 || 'Este campo não pode possuir mais que 30 caracteres'
      ],
      regras50: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 50 || 'Este campo não pode possuir mais que 50 caracteres'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ContatosProjeto', params: {idProjeto: this.idProjeto}})
      },
      editarContatos: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Contatos..' })
        projetos.postContatos(this.idProjeto, this.contatos)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          if (avancar === false) {
            this.$router.push({name: 'ContatosProjeto', params: {idProjeto: this.idProjeto}})
          } else {
            this.$router.push({name: 'IntegrantesProjeto', params: {idProjeto: this.idProjeto}})
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Contatos..' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' })
      projetos.getContatosDoProjeto(this.idProjeto)
      .then(response => {
        this.contatos = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  #v-card-title_label {
    font-size: 12pt;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }

  .tituloSecao {
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// editar-contatos.vue?f076affa